module.exports = __webpack_public_path__ + "static/logo-white-footer-3358995fb79a3e7cf1af71b79990886f.png";